import { createFileRoute } from '@tanstack/react-router'

import PetaniPage from '@/components/pages/backoffice/_klb-petani/_petani/containers/PetaniPage'

export const Route = createFileRoute('/_backoffice/klb-petani/petani/')({
  component: PetaniPage
})
